import client from "./client";
import { UserDetails, User } from "@lab/types/users";
import { DailyDataToken } from "@lab/types/tokens";
import { Dashboard } from "@lab/types/dashboard";

const refresh = async (): Promise<UserDetails | undefined> => {
	const response = await client.get(`/users/details`);
	return response.data as UserDetails;
};

const update = async (user: User): Promise<UserDetails | undefined> => {
	const { id } = user;
	const response = await client.put(`/users/${id}`, user);
	return response.data as UserDetails;
};

const dashboards = async (user: User): Promise<Dashboard[] | undefined> => {
	const { id } = user;
	const response = await client.get(`/users/${id}/dashboards`);
	return response.data as Dashboard[];
};

const fetchTokens = async (
	user: User
): Promise<DailyDataToken[] | undefined> => {
	const { id } = user;
	const response = await client.get(`/users/${id}/tokens`);
	return response.data as DailyDataToken[];
};

const createToken = async (user: User): Promise<DailyDataToken | undefined> => {
	const { id } = user;
	const response = await client.post(`/users/${id}/token`);
	return response.data as DailyDataToken;
};
const revokeToken = async (
	userid: number,
	tokenid: number
): Promise<undefined | undefined> => {
	if (!tokenid || !userid) return undefined;
	const response = await client.delete(`/users/${userid}/token/${tokenid}`);
	return response.data as undefined;
};

const updatePassword = async (
	id: number,
	password: string
): Promise<undefined> => {
	if (!id || !password) return undefined;
	const response = await client.post(`/users/${id}/password`, { password });
	return response.data as undefined;
};

export {
	refresh,
	update,
	dashboards,
	fetchTokens,
	createToken,
	revokeToken,
	updatePassword
};
